import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-world',
  standalone: false,
  templateUrl: './map-world.component.html',
  styleUrl: './map-world.component.scss'
})
export class MapWorldComponent implements AfterViewInit, OnInit {
  clients = [
    { id: 'US', color: 'rgba(95, 30, 217, 0.55)', count: 120 },
    { id: 'CY', color: 'rgba(95, 30, 217, 1)', count: 80 },
    { id: 'CA', color: 'rgba(95, 30, 217, 0.3)', count: 50 },
  ];

  ngOnInit(): void {
    this.updateMap();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateMap();
    }, 150);
  }

  updateMap() {
    this.clients.forEach((client) => {
      this.setCountryColor(client.id, client.color);
      // this.addCountryText(client.id, client.count);
    });

    // this.setStrokeForAllCountries();
    this.addTooltipToCountries();
  }

  setCountryColor(countryId: string, color: string) {
    const country = document.getElementById(countryId);
    if (country) {
      const svgElement = country as unknown as SVGGraphicsElement;
      if (svgElement instanceof SVGGraphicsElement) {
        svgElement.setAttribute('fill', color);
      }
    }
  }

  // addCountryText(countryId: string, count: number) {
  //   const country = document.getElementById(countryId);
  //   if (country) {
  //     const svgElement = country as unknown as SVGGraphicsElement;
  //     if (svgElement instanceof SVGGraphicsElement) {
  //       const bbox = svgElement.getBBox();
  //       const textId = `${countryId}-text`;
  //       let textElement = document.getElementById(
  //         textId
  //       ) as unknown as SVGTextElement;

  //       if (!textElement) {
  //         textElement = document.createElementNS(
  //           'http://www.w3.org/2000/svg',
  //           'text'
  //         ) as SVGTextElement;
  //         textElement.setAttribute('id', textId);
  //         textElement.setAttribute('x', (bbox.x + bbox.width / 2).toString());
  //         textElement.setAttribute('y', (bbox.y + bbox.height / 2).toString());
  //         textElement.setAttribute('fill', 'red');
  //         textElement.setAttribute('font-size', '16px');
  //         textElement.setAttribute('text-anchor', 'middle');
  //         textElement.setAttribute('font-weight', '900');
  //         textElement.textContent = count.toString();

  //         document.querySelector('svg')?.appendChild(textElement);
  //       } else {
  //         textElement.textContent = count.toString();
  //       }
  //     }
  //   }
  // }

  // setStrokeForAllCountries() {
  //   const paths = document.querySelectorAll('svg path');
  //   paths.forEach((path) => {
  //     path.setAttribute('stroke', 'white');
  //     path.setAttribute('stroke-width', '1');
  //   });
  // }

  addTooltipToCountries() {
    const paths = document.querySelectorAll('svg path');

    paths.forEach((path) => {
      const countryId = path.getAttribute('title');
      if (countryId) {
        const title = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'title'
        );
        title.textContent = countryId;
        path.appendChild(title);
      }
    });
  }
}
